import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import AssignmentOutlined from '@mui/icons-material/AssignmentOutlined'
import { MoreButton } from '@sales-center/components'
import * as React from 'react'
import { useMoreOptions } from './hooks'
import type { ActivityType } from '../../../typings'
import useTheme from '@mui/material/styles/useTheme'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

type Props = {
  activityType: ActivityType
}

export function ActivityTypeItem(props: Props) {
  const {
    activityType: { name, id, description },
  } = props
  const options = useMoreOptions({ id })
  const theme = useTheme()

  return (
    <Box mb={2}>
      <Paper>
        <Stack px={2.7} py={2} direction="row" alignItems="center" width={700}>
          {/* Sized past `large` (35px) on purpose. This is a 40x40 layout box;
              the Material glyph only fills 20 of its 24 viewBox units, so the
              painted icon is ~30x33 — matching the 27x34 icon it replaces.
              The box being wider than that pushes the text ~13px right of
              where it used to sit; the row height is unaffected, since the
              subtitle1 + caption block (47.9px) is taller than either icon. */}
          <AssignmentOutlined color="primary" sx={{ fontSize: 40 }} />
          <Box ml={3} mr="auto">
            <Typography variant="subtitle1" color={theme.palette.text.primary}>
              {name}
            </Typography>
            <Typography variant="caption" color={theme.palette.text.primary}>
              {description}
            </Typography>
          </Box>
          <MoreButton
            options={options}
            dataTestId={`activityTypeMoreBtn-${id}`}
          />
        </Stack>
      </Paper>
    </Box>
  )
}
